import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import L, { latLngBounds, LatLngLiteral, LeafletMouseEvent } from "leaflet";
import "../../../assets/css/leaflet/leaflet.css";
import {ReactNode, Ref, useMemo, useRef} from "react";
import marker from "../../../assets/css/leaflet/images/marker.png";
import {MapPlaceholder} from "../../../pages/coinWithdraw/styles";

export interface MarkedLocation extends LatLngLiteral {
  text: string | ReactNode;
  id: string;
}

interface Props {
  defaultLocation: LatLngLiteral;
  markedLocations: MarkedLocation[];
  zoom?: number;
  onClickMarker: (id: string, location: LatLngLiteral) => void;
  height?: number;
}

function BoundsSet({
                     defaultLocation,
                     markedLocations,
                   }: {
  defaultLocation: LatLngLiteral;
  markedLocations: MarkedLocation[];
}) {
  const map = useMap();
  map.setView({lng: defaultLocation.lng, lat: defaultLocation.lat});
  let markerBounds = latLngBounds([]);
  markedLocations.forEach((marker) => {
    markerBounds.extend([marker.lat, marker.lng]);
  });
  markerBounds = markerBounds.pad(0.1);
  map.fitBounds(markerBounds, {animate: true, maxZoom: 16});
  return null;
}

function Map(props: Props) {
  const {defaultLocation, markedLocations, zoom, onClickMarker} = props;
  const refs = useRef<L.Marker<any>[]>([])

  const icon = L.divIcon({
    html: `<img  src="${marker}" alt="marker" style="width: 64px; height: 64px;"/>`,
    className: "dummy",
    iconSize: [64, 64],
    iconAnchor: [32, 64],
  });

  const eventHandlers = useMemo(
    () => ({
      click(e: LeafletMouseEvent) {
        const latlng = e.target.options["data-latlng"].split(",");
        const location: LatLngLiteral = { lat: latlng[0], lng: latlng[1] };
        const id = e.target.options["data-id"];
        onClickMarker(id, location);
      },
      mouseover(e: LeafletMouseEvent) {
        const index = e.target.options['data-index']
        refs.current[index].openPopup();
      },
      mouseout(e: LeafletMouseEvent) {
        const index = e.target.options['data-index']
        refs.current[index].closePopup();
      }

    }),
    []
  );

  return (
    <div style={{ minHeight: `${props.height || 400}px`, width: "100%" }}>
      <MapContainer
        placeholder={<MapPlaceholder />}
        key={`${defaultLocation.lat}${defaultLocation.lng}`}
        style={{
          height: `${props.height || 400}px`,
          width: "100%",
          borderRadius: "16px",
        }}
        center={defaultLocation}
        zoom={zoom || 20}
      >
        <BoundsSet
          defaultLocation={defaultLocation}
          markedLocations={markedLocations}
        />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {markedLocations.map((l, index) => (
          <Marker
            data-index={index}
            data-id={l.id}
            data-latlng={`${l.lat},${l.lng}`}
            eventHandlers={eventHandlers}
            key={index.toString()}
            icon={icon}
            position={{ lat: l.lat, lng: l.lng }}
            ref={(element) => {if (element) {
              refs.current[index] = element
            }}}
          >
            <Popup
              keepInView={true}
              autoClose
              autoPan
              offset={[0, -48]}
              children={l.text}
            />
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}

export default Map;
